import type { IToAnalyticsErrorNameProps } from "./product-analytics.types";

// NOTE: NSAI-2433 / NSAI-6039 — `Error.name` is writable, so "the class name"
// is a convention, not a guarantee. A custom error class, or a library building
// one out of a server response, can put a file name or customer content there.
// An analytics event therefore carries the name only when it is one of these,
// and `Other` for anything else: the failure still counts, without carrying a
// string this code did not choose. Web, mobile and the extension share this set;
// the server keeps a copy in `product-analytics/utils/error-name.util.ts`, held
// in step by its spec. Add to it deliberately; the tracking plan lists it.
const REPORTABLE_ERROR_NAMES: ReadonlySet<string> = new Set([
  "AggregateError",
  "Error",
  "EvalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError",
]);

export const ANALYTICS_UNRECOGNISED_ERROR_NAME = "Other";

// NOTE: Also covers a non-Error throw — React's lifecycle types promise an
// `Error`, JS does not.
export const toAnalyticsErrorName = ({
  error,
}: IToAnalyticsErrorNameProps): string =>
  error instanceof Error && REPORTABLE_ERROR_NAMES.has(error.name)
    ? error.name
    : ANALYTICS_UNRECOGNISED_ERROR_NAME;
